import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Camera, ExternalLink, X } from 'lucide-react';

export const PhotoGallery = () => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const galleryPhotos = [
    {
      id: 1,
      title: "Nadja Scott and Divine Anointing Choir - Emerald Elegance",
      description: "Stunning professional portraits featuring Nadja Scott and Divine Anointing Choir in elegant emerald gowns",
      image: "https://customer-assets.emergentagent.com/job_nadja-divine-choir/artifacts/np8hwoc0_DSC_7620.jpg",
      category: "Professional Photos"
    },
    {
      id: 2,
      title: "Nadja Scott and Divine Anointing Choir - Glamour Session",
      description: "Beautiful portrait session showcasing Nadja Scott and Divine Anointing Choir's elegance and grace",
      image: "https://customer-assets.emergentagent.com/job_nadja-divine-choir/artifacts/lt6xvw7n_DSC_7658.jpg",
      category: "Professional Photos"
    },
    {
      id: 3,
      title: "Nadja Scott and Divine Anointing Choir - Studio Portraits",
      description: "Exquisite studio photography capturing Nadja Scott and Divine Anointing Choir's beauty and sophistication",
      image: "https://customer-assets.emergentagent.com/job_nadja-divine-choir/artifacts/sx7az2fz_DSC_7680.jpg",
      category: "Professional Photos"
    },
    {
      id: 4,
      title: "Nadja Scott and Divine Anointing Choir - Portrait Collection",
      description: "Professional portrait session highlighting Nadja Scott and Divine Anointing Choir's refined artistry",
      image: "https://customer-assets.emergentagent.com/job_nadja-divine-choir/artifacts/354t2503_DSC_7699.jpg",
      category: "Professional Photos"
    },
    {
      id: 5,
      title: "Head Choirmaster Nadja Scott and Associate Choirmaster Charmane Johnson",
      description: "Stunning professional portraits featuring Head Choirmaster Nadja Scott and Associate Choirmaster Charmane Johnson in elegant emerald gowns",
      image: "https://customer-assets.emergentagent.com/job_nadja-divine-choir/artifacts/jk36mknm_DSC_7714.jpg",
      category: "Professional Photos"
    },
    {
      id: 6,
      title: "Nadja Scott and Divine Anointing Choir at Bishop Hezekiah Walker's Choirfest 2025",
      description: "Live performance at the Stellar Awards in Nashville Tennessee - a prestigious gospel music celebration",
      image: "https://customer-assets.emergentagent.com/job_nadja-divine-choir/artifacts/eyfvcma3_IMG_3339.jpeg",
      category: "Stellar Awards"
    },
    {
      id: 7,
      title: "Nadja Scott and DA Soloist Margo Perryman at the 2025 Stellar Awards",
      description: "Powerful worship duo performance at the prestigious 2025 Stellar Awards ceremony",
      image: "https://customer-assets.emergentagent.com/job_nadja-divine-choir/artifacts/sbwwrm8k_IMG_6832.jpeg",
      category: "Stellar Awards"
    },
    {
      id: 8,
      title: "Nadja Scott and Divine Anointing Choir at Gospel Superfest 2026 singing their hit tune Total Praise",
      description: "Powerful performance of the beloved gospel anthem Total Praise at Gospel Superfest 2026 with full production",
      image: "https://customer-assets.emergentagent.com/job_nadja-divine-choir/artifacts/ny5j36zq_IMG_2341.jpeg",
      category: "Gospel Superfest"
    },
    {
      id: 9,
      title: "Nadja Scott and Divine Anointing Choir with The Rose of Gospel Dorinda Clark Cole",
      description: "Spectacular collaboration performance with gospel legend Dorinda Clark Cole showcasing divine musical excellence",
      image: "https://customer-assets.emergentagent.com/job_nadja-divine-choir/artifacts/lou0rqw2_2760299883207806854.jpeg",
      category: "Gospel Legends"
    },
    {
      id: 10,
      title: "Nadja Scott with Chester Burke Jr. and Professor Marcel Wyche",
      description: "Collaborating with renowned choir music songwriters and directors Chester Burke Jr. and Professor Marcel Wyche",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/9urt8l2a_IMG_7536.JPG",
      category: "Collaborations"
    },
    {
      id: 11,
      title: "Nadja Scott and Bishop Khare Hawkins",
      description: "With Bishop Khare Hawkins, renowned songwriter and gospel artist",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/cqiqh0jp_unnamed%20%281%29.jpg",
      category: "Collaborations"
    },
    {
      id: 12,
      title: "Nadja Scott with Pastor Marissa Farrow",
      description: "Fellowship with Pastor Marissa Farrow",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/iu3u0nij_IMG_0349.JPG",
      category: "Ministry"
    },
    {
      id: 13,
      title: "Nadja Scott and Divine Anointing Choir with Charles Jenkins",
      description: "Divine Anointing Choir ministering alongside award-winning gospel artist Charles Jenkins",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/6yv7g8fe_IMG_1967.jpeg",
      category: "Gospel Legends"
    },
    {
      id: 14,
      title: "Nadja Scott with Gospel Artist Zeke and Divine Anointing Manager Joseph Johnson",
      description: "Special moments with gospel artist Zeke and Divine Anointing Manager Joseph Johnson",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/toppjeok_IMG_1979.JPG",
      category: "Collaborations"
    },
    {
      id: 15,
      title: "Divine Anointing Choir",
      description: "The talented members of Divine Anointing Choir in full ensemble",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/h9l97z5x_IMG_2022.JPG",
      category: "Choir"
    },
    {
      id: 16,
      title: "Nadja Scott with Artis Davon Fleming",
      description: "Fellowship with Artis Davon Fleming",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/kd5txzx7_IMG_3980.jpeg",
      category: "Collaborations"
    },
    {
      id: 17,
      title: "Nadja Scott with Kenny, Gospel Artist",
      description: "Ministering with gospel artist Kenny",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/x3frnvjh_IMG_3982.jpeg",
      category: "Gospel Legends"
    },
    {
      id: 18,
      title: "Nadja Scott with Pastor Lee Michaels",
      description: "Fellowship with Pastor Lee Michaels",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/8e0hthtp_IMG_4655.jpeg",
      category: "Ministry"
    },
    {
      id: 19,
      title: "Nadja Scott with Miranda Jackson, Leader of Kadesh Gospel Choir",
      description: "Fellowship with Miranda Jackson, esteemed leader of Kadesh Gospel Choir",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/ot7ye4mq_IMG_4783.JPG",
      category: "Collaborations"
    },
    {
      id: 20,
      title: "Nadja Scott and the Divine Anointing BGV Team with Boss Fred Hammond",
      description: "Divine Anointing's background vocal team with gospel legend Fred Hammond",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/pmdx7kzh_e0821597-4ab4-4138-8927-77a7d5f37bee.JPG",
      category: "Gospel Legends"
    },
    {
      id: 21,
      title: "Nadja Scott with First Award Won - Choir of the Year",
      description: "Celebrating Divine Anointing's first major achievement winning Choir of the Year",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/hnxoin4y_FB_IMG_1530285449896_Original.jpg",
      category: "Awards"
    },
    {
      id: 22,
      title: "Divine Anointing Opens The Rhythm of Gospel Awards",
      description: "Divine Anointing Choir performing at the prestigious Rhythm of Gospel Awards opening",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/3ruxg8fg_FB_IMG_1530873162800_Original.jpg",
      category: "Performances"
    },
    {
      id: 23,
      title: "Nadja Scott with the Late Douglass Miller, Songwriter",
      description: "Precious moments with the late Douglass Miller, legendary songwriter behind 'Pass Me Not' and 'My Soul's Been Anchored in the Lord'",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/ybkdz94u_IMG_0790.JPG",
      category: "Gospel Legends"
    },
    {
      id: 24,
      title: "Nadja Scott with Eldridge Branch, Songwriter",
      description: "Collaboration with renowned songwriter Eldridge Branch",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/itxufhhr_IMG_0290.JPG",
      category: "Collaborations"
    },
    {
      id: 25,
      title: "Nadja Scott with Pastor Shirley Caesar after Winning The Battle of The Bands",
      description: "Celebrating victory with gospel legend Pastor Shirley Caesar after winning her prestigious Battle of The Bands competition",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/s9ta694c_IMG_2569.JPG",
      category: "Awards"
    },
    {
      id: 26,
      title: "Nadja Scott with Famous Photographer",
      description: "Behind the scenes with renowned photographer",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/1wjqhixl_IMG_3454.JPG",
      category: "Behind The Scenes"
    },
    {
      id: 27,
      title: "Nadja Scott with Minister Lauren Riley",
      description: "Fellowship with Minister Lauren Riley",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/97s3bv5n_IMG_3673.JPG",
      category: "Ministry"
    },
    {
      id: 28,
      title: "Nadja Scott Interviewed by Ericka Johnson and Pastor Lee Michaels",
      description: "Nadja Scott sharing her ministry journey in an interview with Ericka Johnson and Pastor Lee Michaels",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/cxden399_IMG_3969.JPG",
      category: "Media"
    },
    {
      id: 29,
      title: "Nadja Scott with Miranda Curtis",
      description: "Fellowship with Miranda Curtis",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/z6zfymnd_IMG_3979.jpg",
      category: "Collaborations"
    },
    {
      id: 30,
      title: "Nadja Scott with Zeke, Gospel Artist and DA Manager Joseph Johnson",
      description: "Special moment with gospel artist Zeke and Divine Anointing Manager Joseph Johnson",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/dcdggeiu_IMG_3992.JPG",
      category: "Collaborations"
    },
    {
      id: 31,
      title: "Nadja Scott with Maurette Brown-Clark and Former DA Assistant Director Bret Lane",
      description: "Fellowship with gospel artist Maurette Brown-Clark and former Divine Anointing Assistant Director Bret Lane",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/arqyk7if_IMG_3993.JPG",
      category: "Gospel Legends"
    },
    {
      id: 32,
      title: "Divine Anointing After Tour Date with Several Artists",
      description: "Divine Anointing Choir celebrating after a successful tour date, with Zeke leading the group",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/3lcgufxd_IMG_4259.JPG",
      category: "Performances"
    },
    {
      id: 33,
      title: "Nadja Scott Preparing for Album Photo Shoot with Zsa Zsa, Famous MUA",
      description: "Behind the scenes with renowned makeup artist Zsa Zsa getting ready for the album photo shoot",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/wilsg14j_IMG_2159.JPG",
      category: "Behind The Scenes"
    },
    {
      id: 34,
      title: "Nadja Scott with Mentor Gospel Artist and Award Winner Dr. Stephen Hurd",
      description: "With mentor and legendary gospel artist Dr. Stephen Hurd, acclaimed award-winning worship leader",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/3cm10b1m_IMG_6019.JPG",
      category: "Gospel Legends"
    },
    {
      id: 35,
      title: "Divine Anointing Choir",
      description: "The powerful ensemble of Divine Anointing Choir ready to minister",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/2gtozwqn_IMG_6155.JPG",
      category: "Choir"
    },
    {
      id: 36,
      title: "Nadja Scott with Amazing Gospel Choir Directors",
      description: "Fellowship and collaboration with exceptional gospel choir directors",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/6h2soc64_IMG_6993.JPG",
      category: "Collaborations"
    },
    {
      id: 37,
      title: "Nadja Scott with Capria McClearn",
      description: "Fellowship with Capria McClearn",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/t1dkiuhp_IMG_7545.JPG",
      category: "Collaborations"
    },
    {
      id: 38,
      title: "Nadja Scott at DA's 1st Live Recording with Writerblok Music Group",
      description: "Historic moment at Divine Anointing's first live recording with Writerblok Music Group under renowned producer Phillip Bryant",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/3bdugszs_IMG_8045.JPG",
      category: "Performances"
    },
    {
      id: 39,
      title: "Choirmaster Brothers and Sisters",
      description: "Fellowship with fellow choirmasters and choir directors",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/s6mauljt_IMG_8577.JPG",
      category: "Collaborations"
    },
    {
      id: 40,
      title: "Divine Anointing Choir",
      description: "The powerful Divine Anointing ensemble ready to minister",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/q5b9xq6v_IMG_9098.JPG",
      category: "Choir"
    },
    {
      id: 41,
      title: "Nadja Scott - Award Winner",
      description: "Nadja Scott celebrating another prestigious award achievement",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/a8by0qor_IMG_9821.JPG",
      category: "Awards"
    },
    {
      id: 42,
      title: "The Divine Anointing Directorship with Overseer Bishop Dr. Dwayne Whitehead",
      description: "Divine Anointing leadership team with Overseer Bishop Dr. Dwayne Whitehead",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/688q6g2v_IMG_0919.JPG",
      category: "Ministry"
    },
    {
      id: 43,
      title: "Nadja Scott with Overseer Bishop Dr. Dwayne Whitehead",
      description: "Nadja Scott with Overseer Bishop Dr. Dwayne Whitehead",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/ifl1akpg_IMG_0927.JPG",
      category: "Ministry"
    },
    {
      id: 44,
      title: "Divine Anointing BGV Team with Fred Hammond",
      description: "Divine Anointing's background vocal team ministering with gospel legend Fred Hammond on stage",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/9o95ai7n_IMG_2094.JPG",
      category: "Gospel Legends"
    },
    {
      id: 45,
      title: "Divine Anointing BGV Team with Fred Hammond",
      description: "Divine Anointing's background vocal team performing alongside gospel legend Fred Hammond",
      image: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/b081187s_IMG_2096.JPG",
      category: "Gospel Legends"
    }
  ];

  return (
    <section id="gallery" className="py-20 bg-black">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-4">
            <Camera className="w-8 h-8 text-red-600 mr-3" />
            <h2 className="text-4xl md:text-5xl font-bold text-white">
              Photo Gallery
            </h2>
          </div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Witness the power and passion of Divine Anointing through these memorable moments from our performances and ministry
          </p>
        </div>

        {/* Photo Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {galleryPhotos.map((photo) => (
            <Card 
              key={photo.id} 
              className="bg-gray-900 border border-gray-700 overflow-hidden hover:shadow-xl transition-shadow group cursor-pointer"
              onClick={() => setSelectedPhoto(photo)}
            >
              <CardContent className="p-0">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img 
                    src={photo.image} 
                    alt={photo.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                    <div className="text-center text-white p-4">
                      <Camera className="w-8 h-8 mx-auto mb-2" />
                      <p className="text-sm font-medium">Click to Enlarge</p>
                    </div>
                  </div>
                  {photo.category && (
                    <div className="absolute top-3 left-3">
                      <span className="bg-red-600 text-white text-xs px-2 py-1 rounded-full font-medium">
                        {photo.category}
                      </span>
                    </div>
                  )}
                </div>
                {(photo.title || photo.description) && (
                  <div className="p-6">
                    {photo.title && <h3 className="font-bold text-white mb-2 text-lg">{photo.title}</h3>}
                    {photo.description && <p className="text-gray-300 text-sm leading-relaxed">{photo.description}</p>}
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Image Modal/Lightbox */}
        {selectedPhoto && (
          <div 
            className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedPhoto(null)}
          >
            <button
              className="absolute top-4 right-4 text-white hover:text-red-600 transition-colors"
              onClick={() => setSelectedPhoto(null)}
            >
              <X className="w-8 h-8" />
            </button>
            <div className="max-w-7xl max-h-[90vh] overflow-auto">
              <img
                src={selectedPhoto.image}
                alt={selectedPhoto.title}
                className="w-full h-auto object-contain"
                onClick={(e) => e.stopPropagation()}
              />
              {(selectedPhoto.title || selectedPhoto.description) && (
                <div className="bg-gray-900 p-6 mt-4 rounded-lg">
                  {selectedPhoto.category && (
                    <span className="bg-red-600 text-white text-xs px-3 py-1 rounded-full font-medium mb-3 inline-block">
                      {selectedPhoto.category}
                    </span>
                  )}
                  {selectedPhoto.title && (
                    <h3 className="text-2xl font-bold text-white mb-2">{selectedPhoto.title}</h3>
                  )}
                  {selectedPhoto.description && (
                    <p className="text-gray-300 text-base">{selectedPhoto.description}</p>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Featured Performance Highlight */}
        <div className="bg-gradient-to-br from-red-50 to-gray-50 rounded-3xl p-8 md:p-12 text-center">
          <h3 className="text-3xl md:text-4xl font-bold text-black mb-4">
            Experience Divine Anointing Live
          </h3>
          <p className="text-lg text-black mb-8 max-w-2xl mx-auto">
            From intimate church services to major concert productions, Divine Anointing brings the same passion, 
            excellence, and spiritual power to every performance. Book us for your next special event.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://docs.google.com/forms/d/12hphFMKBt-Zd44mV26mRSBOZkxx0veNAx_E3yN2YRw8/viewform"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-full text-lg">
                Connect with Us!
              </Button>
            </a>
            <Button variant="outline" className="border-red-600 text-red-600 hover:bg-red-200 px-8 py-3 rounded-full text-lg">
              <ExternalLink className="w-5 h-5 mr-2" />
              View More Photos
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};